import { ILabels } from "./Interfaces";
import { LabelBuilder } from "./LabelBuilder";
import { LanguageOptions } from "./LanguageOptions";

export class Localisation
{
    public terms = 'TERMS';

    private _languages?: LanguageOptions;
    public get languages(): LanguageOptions
    {
        if (!this._languages)
        {
            throw new Error('You must call localisation.createLanguageOptions() in the application startup.');
        }
        return this._languages;
    }

    public useDateTimeExtensions(): Localisation
    {
        // todo: move myDateTime.toLocaleDateString(), myDateTime.toLocaleTimeString(), myDateTime.toLocaleDateTimeString() into this package
        // todo: move myDateTime.toUtcByNode(), myDateTime.toIsoByNode(), myDateTime.setZoneByNode(), myDateTime.offsetTimeByNode() into this package
        // todo: move DateTime.fromIsoByNode(), DateTime.today(..., nodeId), DateTime.now(..., nodeId) into this package
        return this;
    }

    public useNumberExtensions(): Localisation
    {
        // todo: create a myNumber.toLocaleString(...) method
        // todo: create a Number.fromLocaleString(...) method
        return this;
    }

    public createLanguageOptions(): LanguageOptions
    {
        this._languages = new LanguageOptions(this);
        return this.languages;
    }

    public createLabelBuilder<TLabels extends ILabels>(labels: TLabels): LabelBuilder<TLabels>
    {
        return new LabelBuilder(this, labels);
    }
}
